import { onAuthStateChanged, User } from 'firebase/auth'

import { auth } from 'src/configuration-firebase'

export class UserInitializeService {
  protected user!: User

  private userInitialized: boolean = false

  private userPromise: Promise<void> | null = null

  constructor() {
    this.initializeUser()
  }

  private initializeUser(): void {
    this.userPromise = new Promise(resolve => {
      onAuthStateChanged(auth, user => {
        if (user) {
          this.user = user
          this.userInitialized = true
          resolve()
        }
      })
    })
  }

  protected async waitForUserInitialization(): Promise<void> {
    if (!this.userInitialized) {
      await this.userPromise
    }
  }

  protected async getUserCollectionName(): Promise<string> {
    await this.waitForUserInitialization()

    if (this.user) {
      return this.user.email?.replace('@', '_').replace('.', '_') || ''
    }

    return 'default'
  }
}
